import { dateToTimestamp } from 'shared/helpers/parsers/date';

const parseLotInspectionData = inspection => ({
  inspectionScheduledFor: dateToTimestamp(inspection.inspectionScheduledFor),
});

export { parseLotInspectionData };
